export default "__VITE_ASSET__CyKjkKQd__"